import { sendGet } from './axios';

export const getAllResource = (payload) => sendGet(`/agent-resource`, payload);

export const getAllStateAgent = (payload) => sendGet(`/agent-state`, payload);

export const getAllAgentNameState = () => sendGet(`/agent-name-state`);

export const getAllAreaByAgent = (stateId) => sendGet(`/agent-area/${stateId}`);
